// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".profile-customer-review{font-size:16px;font-weight:400}.profile-customer-review .container,.profile-customer-review__heading{padding-left:30px;padding-right:30px}.profile-customer-review__heading{font-size:24px;font-weight:400;line-height:32px;padding-top:21px}.profile-customer-review__actions{padding:14px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
